import { Box, Grid, Text, Tooltip } from '@chakra-ui/react'
import { Taxas } from './Taxas'

export function CardTransp({ item, selected, selectRow, index, isGratis }) {
  // Não renderiza o componente se for Melhor Envio ou se não tiver nome
  if (!item.nome || item.isMelhorEnvio) return null

  return (
    <Grid
      key={index}
      templateColumns={'2fr 1fr 1fr 1fr'}
      bgColor="transparent"
      paddingBlock=".8rem"
      border={`1px solid ${isGratis ? '#95c620' : '#e9e9e9'}`}
      mt="1rem"
      transition="all .2s ease-in-out"
      backgroundColor={selected?.id === item.id ? '#e9e9e9' : 'transparent'}
      transform={selected?.id === item.id ? 'scale(1.01)' : 'scale(1)'}
      cursor="pointer"
      _hover={{
        background: '#e9e9e9',
        borderColor: '#e9e9e9',
        transform: 'scale(1.01)',
      }}
      onClick={() => selectRow(item)}
      position="relative"
      overflow="hidden"
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        bgColor="#989898"
        padding="0 .2rem"
        color="#fff"
        display="flex"
        alignItems="center"
        justifyContent="center"
        textTransform="uppercase"
        letterSpacing="1px"
      >
        <Text as="span" m="0" fontSize=".6rem" textAlign="center" fontWeight="bold">
          {item.isMelhorEnvio ? 'Melhor Envio' : item.isKangu ? 'Kangu' : item.isFedex ? 'TNT' : ''}
        </Text>
      </Box>
      <Text as="span" m="0" fontSize=".9rem" textAlign="start" paddingLeft="1rem">
        {item.nome}
      </Text>

      <Text position="absolute" top="50%" left="15%" transform="translate(-50%, -50%)">
        {item.nome === 'TNT' && (
          <Tooltip
            width="500px"
            label={
              <Grid gridTemplateRows="1fr 1fr" gap={3} color="#fff" borderRadius="5px">
                <Taxas taxas={item.taxas} />
              </Grid>
            }
            aria-label="A tooltip"
          >
            <Text
              as="span"
              m="0"
              fontSize=".6rem"
              textAlign="center"
              fontWeight="bold"
              color="red.500"
              border="1px solid"
              borderColor="red.500"
              px={2}
              py={1}
              borderRadius="15px"
            >
              Ver taxas
            </Text>
          </Tooltip>
        )}
      </Text>

      {item.isFreeSp && (
        <Box
          position="absolute"
          top="50%"
          left="30%"
          transform="translate(-50%, -50%)"
          bgColor="#95c620"
          padding="0 .5rem"
          color="#fff"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="5px"
          textTransform="uppercase"
          letterSpacing="1px"
        >
          <Text as="span" m="0" fontSize=".7rem" textAlign="center" fontWeight="bold">
            {item.flag}
          </Text>
        </Box>
      )}
      {isGratis && (
        <Box
          position="absolute"
          top="50%"
          left="30%"
          transform="translate(-50%, -50%)"
          bgColor="#95c620"
          padding="0 .5rem"
          color="#fff"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="5px"
          textTransform="uppercase"
          letterSpacing="1px"
        >
          <Text as="span" m="0" fontSize=".7rem" textAlign="center" fontWeight="bold">
            Grátis
          </Text>
        </Box>
      )}

      <Text as="span" m="0" fontSize=".9rem" textAlign="center">
        {item?.prazo?.max} {item?.prazo?.max > 1 ? 'dias úteis' : 'dia útil'}
      </Text>
      <Text as="span" m="0" fontSize=".9rem" textAlign="center">
        {item.preco === 0
          ? 'Grátis'
          : new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(parseFloat(item.preco))}
      </Text>
      <Text as="span" m="0" fontSize=".9rem" textAlign="center" fontWeight="bold">
        {item.preco === 0
          ? 'Grátis'
          : new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(parseFloat(item.preco * 1.3))}
      </Text>
    </Grid>
  )
}
